import { z } from 'zod';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

const searchSchema = z.object({
  view: z.enum(['list', 'calendar']).default('list'),
  phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
});

/**
 * Schema for validating search parameters in the calendar view.
 * Extends the global search schema and includes view mode selection.
 */
export const calendarSearchSchema = globalSearchSchema.merge(searchSchema);

/**
 * Type definition for the calendar search parameters.
 */
export type CalendarSearch = z.infer<typeof calendarSearchSchema>;
